import React from "react";
// Assuming Header and Footer are now in their own files
import Header from "./Header";
import Footer from "./Footer";
import { BRAND } from "../config/brandConfig"; // Must import BRAND config

function SiteLayout({ children }) {
  return (
    <div
      className="app-root"
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        backgroundColor: BRAND.colors.bg,
      }}
    >
      <Header />
      <main
        style={{
          flex: 1,
          // SCROLL UPGRADE: Using BRAND tokens for padding and max width
          padding: `${BRAND.layout.verticalPadding} ${BRAND.layout.container.paddingX}`,
          maxWidth: BRAND.layout.container.maxWidth,
          margin: "0 auto",
          width: "100%",

          // ✨ NEW FIX: Override padding top for better visual separation from the fixed Header
          paddingTop: "4rem",
        }}
      >
        {children}
      </main>
      <Footer />
    </div>
  );
}

export default SiteLayout;
